import { Request, HttpResponse } from "./request"
import { BookingModel } from "../models/booking.model"
import { state } from "../reactive/admin.state"
import { FacilityModel } from "../models/facility.model"

export interface LoginDto {
  username: string
  password: string
}

const request = Request("/admin")

export async function findAllFacilities(): Promise<
  HttpResponse<FacilityModel[]>
> {
  return request()
    .method("GET")
    .url("/facility")
    .useBearer(state.accessToken || "")
    .isList()
    .returns(FacilityModel)
    .fire()
}

export async function findOneFacility(
  id: string,
): Promise<HttpResponse<FacilityModel>> {
  return request()
    .method("GET")
    .url(`/facility/${id}`)
    .useBearer(state.accessToken || "")
    .returns(FacilityModel)
    .fire()
}

export async function findBookingsOfFacility(
  facilityId: string,
): Promise<HttpResponse<BookingModel[]>> {
  return request()
    .method("GET")
    .url(`/facility/${facilityId}/booking`)
    .useBearer(state.accessToken || "")
    .returns(BookingModel)
    .isList()
    .fire()
}
